module.exports = __webpack_public_path__ + "static/media/WheatStage114.16171a56.PNG";